'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Divider = require('../../Divider-c61d5898.js');
require('@babel/runtime/helpers/extends');
require('@babel/runtime/helpers/objectWithoutProperties');
require('react');
require('../../parseDataAttributes-81c8dbee.js');
require('@babel/runtime/helpers/slicedToArray');
require('lodash/fp/fromPairs');
require('lodash/fp/map');
require('lodash/fp/toPairs');
require('lodash/fp/flow');
require('@babel/runtime/helpers/taggedTemplateLiteral');
require('@emotion/styled');
require('@emotion/react');



exports.Divider = Divider.Divider;
//# sourceMappingURL=index.js.map
